import Icon from '../components/Icon.vue'

Icon.register({
  'level-down-alt': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M313.6 392.3l-104 112c-9.5 10.2-25.7 10.2-35.2 0l-104-112c-14.2-15.3-3.4-40.3 17.6-40.3h64v-272h-84 0c-2.7 0-6.5-1.6-8.5-3.5l-56-56c-7.6-7.6-2.2-20.5 8.5-20.5h196c13.3 0 24 10.7 24 24v328h64c20.9 0 31.9 25 17.6 40.3z'
      }
    ]
  }
})
